
import { createAction, props } from '@ngrx/store';

export const loadCorporateSignupConfigData = createAction('[Data CorporateSignupConfig API] Load Data',);
export const loadCorporateSignupConfigDataSuccess = createAction('[Data CorporateSignupConfig API] Load Data Success', props<any>());
export const loadCorporateSignupConfigDataFailure = createAction('[Data CorporateSignupConfig API] Load Data Failure', props<any>());
